import React, { memo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { closeDrawer, setDiscoverLoading } from 'modules/navigation/navigation.actions';
import { setCommunity } from 'modules/auth/auth.actions';
import CommunityActive from 'modules/community/communityActive.component';
import CommunityListItem from 'modules/community/communityListItem.component';
import { SIDE_NAV_PADDING } from 'styles/layout';
import { useUnread } from './hooks';
import { useLocation } from 'react-router-dom';
import { Pressable, Box, Row, View, BodyText, Badge } from 'modules/styled';

Community.propTypes = {
  viewCommunityMembers: PropTypes.func,
  showSettings: PropTypes.func,
};

export function Community({ viewCommunityMembers, showSettings }) {
  const community = useSelector((state) => state.community);
  const auth = useSelector((state) => state.auth);
  const view = useSelector((state) => state.navigation.discover);
  const screenSize = useSelector((state) => state.navigation.screenSize);

  const { communityMembers, members, communities, userCommunities, userMemberships } =
    community;

  const activeCommunity = communities?.[community.active];
  const activeMembers =
    communityMembers?.[community?.active]?.map((id) => members[id]) || [];

  return (
    <Box sx={{ flex: 1 }}>
      <Box sx={{ variant: 'borders.navBorder', borderBottomWidth: 1 }}>
        {activeCommunity && (
          <CommunityActive
            key={activeCommunity._id}
            community={activeCommunity}
            userCommunities={userCommunities}
            userMemberships={userMemberships}
            members={activeMembers}
            screenSize={screenSize}
            viewCommunityMembers={viewCommunityMembers}
            showSettings={showSettings}
            view={view}
            auth={auth}
          >
            <MemoCommunityLink community={activeCommunity} active />
          </CommunityActive>
        )}
        <View sx={{ my: 2 }}>
          <OtherCommunities />
        </View>
      </Box>
      <BodyText sx={{ m: [2, SIDE_NAV_PADDING] }}>
        We'll be adding more communities soon!{'\n\n'}
      </BodyText>
    </Box>
  );
}

const OtherCommunities = memo(() => {
  const { communities, list, active } = useSelector((state) => state.community);
  if (!list) return null;
  return list
    .map((id) => communities[id])
    .filter((community) => community && active !== community.slug)
    .map((community) => <MemoCommunityLink key={community._id} community={community} />);
});

CommunityLink.propTypes = {
  community: PropTypes.object,
  active: PropTypes.bool,
};

const MemoCommunityLink = memo(CommunityLink);

function CommunityLink({ community, active }) {
  const dispatch = useDispatch();
  const unread = useUnread(community, active);
  const loc = useLocation();
  const currentCommunity = useSelector((state) => state.auth.community);

  return (
    <Box sx={{ flex: 1 }}>
      <Pressable
        bgHover={'white'}
        hu
        key={community._id}
        to={
          currentCommunity === community.slug
            ? '/' + community.slug + '/top'
            : loc?.pathname?.match('user/profile')
            ? loc?.pathname
            : '/' + community.slug + '/top'
        }
        webAction={() => {
          if (loc?.pathname?.match('user/profile'))
            dispatch(setCommunity(community.slug));
        }}
        nativeAction={() => {
          dispatch(setDiscoverLoading(true));
          // dispatch(resetTabs());
          dispatch(closeDrawer());
          requestAnimationFrame(() => {
            dispatch(setCommunity(community.slug));
            dispatch(setDiscoverLoading(false));
          });
        }}
      >
        <Row
          sx={{
            alignItems: 'center',
            justifyContent: 'space-between',
            py: 1,
            px: [2, SIDE_NAV_PADDING],
          }}
        >
          <CommunityListItem community={community} />
        </Row>
      </Pressable>
      <Badge
        sx={{ position: 'absolute', top: 2, right: 0, mr: [SIDE_NAV_PADDING, 2] }}
        number={unread}
      />
    </Box>
  );
}

export default memo(Community);
